import Vue from 'vue'
import Vuex from 'vuex'
import appService from '../server/app.service'
import usersModule from './modules/users'
import projectsModule from './modules/projects'
import scriptTypesModule from './modules/scriptTypes'
import languagesModule from './modules/languages'
import librariesModule from './modules/libraries'
import translationsModule from './modules/translations'
import settingsModule from './modules/settings'
import _ from 'lodash'

import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex)

const state = {
    isAuthenticated: false,
    miniVariant:false,
    messages: [],
}

const store = new Vuex.Store({
    modules: {
        usersModule,
        projectsModule,
        scriptTypesModule,
        librariesModule,
        languagesModule,
        translationsModule,
        settingsModule
    },
    state,
    getters: {
        isAuthenticated: (state) => {
            return state.isAuthenticated
        },
        miniVariant: (state) => {
            return state.miniVariant
        },
        messages: (state) => {
            return state.messages
        },
        getField,
    },
    actions: {
        changeMiniVariant(context) {
            context.commit('changeMiniVariant')
        },
        logout (context) {
            context.commit('logout')
        },
        login (context, credentials) {
            return new Promise((resolve) => {
                appService.connectToServer(credentials)
                    .then((data) => {
                        context.commit('login', data)
                        resolve()
                    })
                    .catch(() => window.alert('Could not login!'))
            })
        },
        changeAuthenticated: (context, value) => {
            context.commit('changeAuthenticated', value)
        },
        addMessage (context, content) {
            context.commit('addMessage', content)
        },
        deleteMessage (context, id) {
            context.commit('deleteMessage', id)
        },
    },
    mutations: {
        changeMiniVariant (state) {
            if (typeof window !== 'undefined') {
                window.localStorage.setItem('miniVariant', !state.miniVariant)
            }
            state.miniVariant = !state.miniVariant
        },

        logout (state) {
            if (typeof window !== 'undefined') {
                window.localStorage.setItem('token', null)
                window.localStorage.setItem('tokenExpiration', null)
                window.localStorage.setItem('role_id', 0)
            }
            state.isAuthenticated = false
        },
        login (state, loginData) {
            if(loginData.success) {
                if (typeof window !== 'undefined') {
                    window.localStorage.setItem('token', loginData.token)
                    window.localStorage.setItem('role_id', loginData.role_id)
                    var tokenExpiration = (new Date().getTime() / 1000) + loginData.expires_in
                    window.localStorage.setItem('tokenExpiration', tokenExpiration)
                }
                state.isAuthenticated = true
            } else {
                state.isAuthenticated = false
                this.dispatch('addMessage', loginData)
            }

        },
        changeAuthenticated: (context, value) => {
            state.isAuthenticated = value
        },
        addMessage (state, content) {
            state.messages.push({id: parseInt(Math.random() * 100000), msg: content})
        },
        deleteMessage (state, id) {
            let index = _.findIndex(state.messages, function(o) { return o.id == id })
            state.messages.splice(index, 1)
        },
        updateField,
    }

})

if (typeof window !== 'undefined') {

        if (typeof  window.localStorage.getItem('miniVariant') !== 'undefined') {
            store.state.miniVariant = JSON.parse(window.localStorage.getItem('miniVariant'));
        }
        // controllo il token
        let expiration = window.localStorage.getItem('tokenExpiration')
        var unixTimestamp = new Date().getTime() / 1000

        if (expiration !== null && parseInt(expiration) - unixTimestamp > 0) {
            store.state.isAuthenticated = true
        }

        /*let token = window.localStorage.getItem('token')
        if(token != '' && token != 'null') {
            store.state.isAuthenticated = true
        }*/

}


export default store
